export function createDefaultTenant(overrides = {}) {
  return {
    id: 0,
    tenantCode: "",
    enabled: true,
    tenantName: "",
    contactPerson:"",
    contactEmail:"",
    contactPhone:"",
    contactAddress:"",
    tenantApiKey: "",
    isDelete: false,
    modifiedDate: 0,
    createdBy: "",
    modifiedBy: "",
    createdDate: 0,
    multitenancy: true,
    billingCycle: "MONTHLY",
    monthlyRate: 0,
    annualRate: 0,
    paymentStatus: "TRIAL",
    statusStartDate: new Date().toISOString(),
    statusEndDate: new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString(),
    subTenantDTOList: [],
    currency: "USD",
    ...overrides,  // override any defaults by passing props
  };
}